import FormattedMessage from 'I18n/components/FormattedMessage';
import { ButtonIconBreezeTooltip, Drawer, LayoutBox, LayoutHorizontal } from 'breeze-intelligence-kit';
import { When } from 'policy-lib';
import { useDataTest } from './useDataTest/useDataTest';
import { UpgradeLink } from '../UpgradeLink';
import { ENRICHMENT_DATA_TEST_UPGRADE_SOURCE } from '../../constants';
import { CreditsPanelMessage } from '../CreditsAvailable/CreditsPanelMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function DataTestFooter() {
  const {
    enrichmentPolicy,
    hasError,
    isLoading,
    onEnrich,
    recordsEnrichable
  } = useDataTest();
  const isReadyToEnrich = !hasError && !isLoading;
  const hasEnrichableRecords = recordsEnrichable > 0;
  const isMainButtonDisabled = !isReadyToEnrich || !enrichmentPolicy.accessEnrichment() || !hasEnrichableRecords;
  const showCredits = enrichmentPolicy.viewCredits();
  const TooltipMessage = () => {
    if (hasEnrichableRecords) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dataTest.panel.addonTooltip"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dataTest.panel.noAvailableRecords"
    });
  };
  return /*#__PURE__*/_jsx(Drawer.Footer, {
    children: /*#__PURE__*/_jsxs(LayoutHorizontal, {
      alignItems: "center",
      blockSize: "100%",
      flexGrow: 1,
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsxs(LayoutHorizontal, {
        children: [/*#__PURE__*/_jsx(LayoutBox, {
          flex: "0 0 auto",
          children: /*#__PURE__*/_jsx(ButtonIconBreezeTooltip, {
            disabled: isMainButtonDisabled,
            onClick: onEnrich,
            placement: "top",
            tooltip: /*#__PURE__*/_jsx(TooltipMessage, {}),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "dataTest.panel.enrich"
            })
          })
        }), /*#__PURE__*/_jsx(CreditsPanelMessage, {
          showCredits: showCredits
        })]
      }), /*#__PURE__*/_jsx(When, {
        can: "viewAddonCTA",
        policy: enrichmentPolicy,
        children: /*#__PURE__*/_jsx(UpgradeLink, {
          upgradeSource: ENRICHMENT_DATA_TEST_UPGRADE_SOURCE,
          variant: "tertiary-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "dataTest.panel.addonCTA"
          })
        })
      })]
    })
  });
}